import * as ActionTypes from '../actions/UserActions';
import cogoToast from 'cogo-toast';
import _ from 'lodash';

export const user = (
  state = {
    profile: {},
    realProfile: null, // Used for Superuser Mocking
    tokens: {},
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.SAVE_REAL_USER_PROFILE:
      return {
        ...state,
        realProfile: action.user,
      };

    case ActionTypes.CLEAR_REAL_USER_PROFILE:
      return {
        ...state,
        realProfile: null,
      };

    case ActionTypes.SYNC_USER_SUCCESS:
      state.realProfile && !action.skipLogging && cogoToast.info(`Currently pretending to be ${action.user?.first_name}`);
      return {
        ...state,
        profile: action.user,
      };

    case ActionTypes.LOGIN_USER_SUCCESS:
      cogoToast.success('Successfully logged in.');
      return {
        ...state,
        profile: action.user,
        tokens: action.tokens,
      };

    case ActionTypes.REGISTER_USER_SUCCESS:
      cogoToast.success('Successfully created an account.');
      return {
        ...state,
        profile: action.user,
        tokens: action.tokens,
      };

    case ActionTypes.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        tokens: action.tokens,
      };

    case ActionTypes.LOGIN_USER_FAILURE:
    case ActionTypes.REGISTER_USER_FAILURE:
      cogoToast.error(_.first(_.values(action.error)) || 'There was an error.');
      return {
        ...state,
      };

    case ActionTypes.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        profile: {},
        realProfile: null,
        tokens: {},
      };

    default:
      return state;
  }
};
